export { cn } from "cn";

export function formatDateTime(
  value: string | null | undefined,
  fallback = "—",
  timeZone?: string,
) {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone || "UTC",
    timeZoneName: "short",
  }).format(date);
}

export function formatDate(
  value: string | null | undefined,
  fallback = "Perpetual",
  timeZone?: string,
) {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: timeZone || "UTC",
  }).format(date);
}

export function compactId(value: string, length = 16) {
  if (value.length <= length) return value;
  return `${value.slice(0, Math.max(4, length - 7))}…${value.slice(-6)}`;
}

export function humanizeAction(value: string) {
  return value
    .replace(/[._-]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function parseJsonObject(value: string): Record<string, unknown> {
  const parsed: unknown = JSON.parse(value);
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error("Expected a JSON object.");
  }
  return parsed as Record<string, unknown>;
}
